import React from 'react';
import { observer } from 'mobx-react';

import { Box, IconButton, Tooltip } from 'components';
import { Download } from 'icons';

const alignCenterStyle = {
  display: 'flex',
  alignItems: 'center',
};

interface ActionButtonsProps {
  receiptUrl?: string;
}

const tipText = 'Download invoice';

export const ActionButtons = observer(function ActionButtons({
  receiptUrl,
}: ActionButtonsProps) {
  if (!receiptUrl) {
    return null;
  }

  return (
    <Box sx={alignCenterStyle}>
      <Tooltip id={tipText} place='bottom' delayShow={1000} />
      <a download href={receiptUrl}>
        <IconButton
          variant='outlined'
          data-tip={tipText}
          data-for={tipText}
          icon={<Download />}
          mr={4}
        />
      </a>
    </Box>
  );
});
